import React from 'react';
import { MapPin, ChevronDown } from 'lucide-react';
import { UserLocationState, cleanAreaName } from '../services/locationService';

interface LocationPillProps {
  location: UserLocationState | null;
  onClick: () => void;
}

export const LocationPill: React.FC<LocationPillProps> = ({ location, onClick }) => {
  const isServiceable = location?.status === 'serviceable';
  const isUnserviceable = location?.status === 'unserviceable';

  let text = 'Deliver to: Bhilai (within 5 km)';
  let dotClass = 'is-default';

  if (isServiceable) {
    const shortName = cleanAreaName(location.areaName);
    text = `Deliver to: ${shortName}`;
    dotClass = 'is-online';
  } else if (isUnserviceable) {
    const shortName = cleanAreaName(location.areaName);
    text = `Deliver to: ${shortName} (Coming Soon)`;
    dotClass = 'is-offline';
  }

  return (
    <button
      type="button"
      className={`nav-location-badge-btn ${isUnserviceable ? 'is-out-of-area' : ''}`}
      onClick={onClick}
      title="Check or change doorstep parlour delivery area"
      aria-label="Change delivery location"
    >
      <span className={`location-status-dot ${dotClass}`} />
      <MapPin size={12} className="location-pin-icon" />
      <span className="location-badge-text">{text}</span>
      <ChevronDown size={11} className="location-arrow-icon" />
    </button>
  );
};
